import styles from "./NotificationDetailModal.module.scss";
import Modal from "../../Common/Modal/Modal";
import moment from "moment";
import React from "react";

export interface UserNotification {
  buildingId: number;
  createdAt: string;
  isActive: boolean;
  message: string;
  messageSent: boolean;
  notificationId: number;
  seenByMember: boolean;
  tags: string[] | null;
  title: string;
}

interface Props {
  isOpen: boolean;
  setIsOpen: React.Dispatch<React.SetStateAction<boolean>>;
  notification: UserNotification | null;
}

function NotificationDetailModal(props: Props) {
  const { isOpen, setIsOpen, notification } = props;

  return (
    <Modal isOpen={isOpen} setIsOpen={setIsOpen}>
      <div className={styles.mainContainer}>
        <div className={styles.headingContainer}>
          <h1 className={styles.heading}>{notification?.title}</h1>
        </div>
        <div className={styles.bodyContainer}>
          <p className={styles.time}>
            {moment(notification?.createdAt).format("MMM D, YYYY · h:mm A")}
          </p>
          <p className={styles.message}>{notification?.message}</p>
        </div>
      </div>
    </Modal>
  );
}

export default NotificationDetailModal;
